angular.module('SpidApp')

.factory('ConfigService',
	    ['Restangular', '_',
function (Restangular,   _) {
	var ConfigService = {
		all: function () {
			return Restangular.all('configs').getList().then(function (configs) {
				return _.reduce(configs, function (memo, config) {
					switch (config.key) {
						case 'agency_id' :
							memo.agencyId = +config.value
							break
						case 'last_sync_iso_date' :
							memo.lastSyncIsoDate = config.value
							break
						default:
							memo[config.key] = config.value
					}

					return memo
				}, {})
			})
		},

		save: function (key, value) {
			if (!key || !value) {
				throw 'ConfigService::save() - Missing parameters'
			}

			return Restangular.one('configs', key).post(null, {value: value})
		}
	}

	return ConfigService
}])